<template>
    <div class="alkali">
        <p>
            typische Flammenfärbung (Feuerwerk)
        </p>
    </div>
</template>

<script>
export default {
    name: 'alkali',
};
</script>
